import { Page } from "@shopify/polaris";
import StoreDetails from "./subcomponents/StoreDetails";
import GMCSettings from "./subcomponents/GMCSettings";
import SubmitFeed from "./subcomponents/SubmitFeed";

const StoreDetailSettings = () => {
  return (
    <Page narrowWidth>
      <div style={{ display: "flex", flexDirection: "column", rowGap: "15px" }}>
        <StoreDetails />
        <GMCSettings />
        <SubmitFeed />
      </div>
    </Page>
  );
};

export default StoreDetailSettings;
